import { logEvent, type Analytics } from "firebase/analytics";
import type { AnalyticsSink } from "@yjsgames/analytics-ports";

/**
 * GA4 Analytics sink — `logEvent`로 게임 이벤트를 전송한다.
 * 이벤트명은 snake_case(`chapter_clear` 등)로 두어 `/ga-export`·GA4 대시보드 집계와 호환.
 */
export class FirebaseAnalyticsSink implements AnalyticsSink {
  constructor(private readonly analytics: Analytics) {}

  log(event: string, params?: Record<string, string | number>): void {
    logEvent(this.analytics, event, params);
  }
}
